<template>
  <div class="logsContainer">
    <h1>Logs room {{ roomId }}</h1>

    <form>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="datesFolders">Date</label>
          <select
            name="datesFolders"
            id="datesFolders"
            class="form-control"
            @change="updateListFiles($event.target.value)"
          >
            <option value="">Choisir une date</option>
            <option
              v-for="(date, index) in datesFolders"
              :key="'date_' + index"
              :value="date"
            >
              {{ date }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="logsFiles">Fichier</label>
          <select
            name="logsFiles"
            id="logsFiles"
            class="form-control"
            :disabled="!date"
            @change="selectLogFile($event.target.value)"
          >
            <option value="">Choisir un fichier</option>
            <option
              v-for="(file, index) in logsFiles"
              :key="'file_' + index"
              :value="file"
            >
              {{ file }}
            </option>
          </select>
        </div>
      </div>
    </form>

    <log-viewer :log="logs" />
  </div>
</template>

<script>
  import axios from 'axios'
  import LogViewer from '@femessage/log-viewer'

  export default {
    name: 'Logs',
    props: ['roomId'],
    components: {
      LogViewer,
    },
    computed: {
      token: () => localStorage.getItem('jwt'),
      filepath() {
        if (!this.date || !this.logFile) {
          return null
        }

        return `/api/room/${this.roomId}/logs/${this.date}/${this.logFile}`
      },
      loading() {
        return !!this.filepath
      },
    },
    data() {
      return {
        datesFolders: [],
        logsFiles: [],

        date: null,
        logFile: null,

        logs: '',
      }
    },
    methods: {
      async init() {
        this.datesFolders = await this.getDatesSelectList()
      },
      async getDatesSelectList() {
        let response = await axios.get(
          '/api/room/' + this.roomId + '/logs/select',
          {
            withCredentials: true,
            headers: {
              Authorization: 'Bearer ' + this.token,
            },
          }
        )

        return response.data
      },
      async updateListFiles(date) {
        this.date = date

        if (!date) {
          this.logsFiles = ''
          this.resetLogs()
          return
        }
        let response = await axios.get(
          '/api/room/' + this.roomId + '/logs/select',
          {
            withCredentials: true,
            headers: {
              Authorization: 'Bearer ' + this.token,
            },
            params: {
              date: date,
            },
          }
        )

        this.logsFiles = response.data
      },
      async selectLogFile(file) {
        this.logFile = file
        this.loadLogs()
      },
      async loadLogs() {
        if (!this.filepath) {
          this.resetLogs()
          return
        }
        let response = await axios.get(this.filepath, {
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + this.token,
          },
        })

        this.logs = response.data
      },
      resetLogs() {
        this.logs = ''
      },
    },
    mounted() {
      //   const token = localStorage.getItem('jwt');
      if (!this.token) {
        this.$router.push('/login')
      }

      this.init()
      //   if(token){
      //       axios
      //         .get('/logs/' + this.roomId, {
      //             params: {
      //               startDate: this.startDate,
      //               endDate: this.endDate
      //             },
      //             withCredentials: true,
      //             headers: {
      //             'Authorization': 'Bearer ' + token
      //         }
      //         })
      //         .then(response => {
      //             this.logs = response.data;
      //         })
      //         .catch(() => {
      //             this.$router.push("/login");
      //         });
      //     } else {
      //         this.$router.push("/login");
      //     }
    },
  }
</script>
<style>
  .logsContainer {
    margin: 2%;
  }
</style>
